import { ACTION_TYPES, TOKEN_TYPES } from "../utils/enums";
import { mergeConfigs } from "../utils/substitutions";
import { defaultInitialState } from "./index";

export const reducer = (state, action) => {
  let newState = state;
  switch(action.type){
    case ACTION_TYPES.SET_HEALTH_CHECK_PASSED_OR_NOT_REQUIRED:
      newState = {
        ...state,
        healthCheckPassedOrNotRequired: action.payload,
      };
      break;
    case ACTION_TYPES.FORCE_RE_RENDER:
      newState = {
        ...state,
        renderId: action.payload,
      };
      break;
    case ACTION_TYPES.START_OVER:
      newState = defaultInitialState;
      break;
    case ACTION_TYPES.PAYMENT.SET:
      newState = {
        ...state,
        payment: action.payload,
      };
      break;
    case ACTION_TYPES.PAYMENT.UPDATE:
      newState = {
        ...state,
        payment: {
          ...state.payment,
          ...action.payload,
        }
      };
      break;
    case ACTION_TYPES.MODALS.PUSH:
      newState = {
        ...state,
        modals: [...state.modals, {...action.props}],
      };
      break;
    case ACTION_TYPES.MODALS.POP:
      newState = {
        ...state,
        modals: state.modals.slice(0, state.modals.length - 1),
      };
      break;
    case ACTION_TYPES.CONFIGURATION.UPDATE:
      newState = {
        ...state,
        configuration: mergeConfigs(state.configuration, action.payload),
      };
      break;
    case ACTION_TYPES.ACCOUNTS.SET:
      newState = {
        ...state,
        accounts: action.payload,
      };
      break;
    case ACTION_TYPES.SELECTED_PAYMENT_NETWORK.SET:
      newState = {
        ...state,
        selectedPaymentNetwork: action.payload,
      };
      break;
    case ACTION_TYPES.SELECTED_PAYMENT_NETWORK.RESET:
      newState = {
        ...state,
        tokens: {
          ...state.tokens,
          [TOKEN_TYPES.RECIPIENT_LOGIN]: null, // for now reset any recipient login tokens. if the user happens to select the same payment network, we could potentially re-use the same token
        },
        selectedPaymentNetwork: null,
      };
      break;
    case ACTION_TYPES.TOKENS.SET:
      newState = {
        ...state,
        tokens: {
          ...state.tokens,
          [action.tokenType]: action.tokenValue,
        }
      };
      break;
    case ACTION_TYPES.TOKENS.RESET:
      newState = {
        ...state,
        tokens: defaultInitialState.tokens,
      };
      break;
    case ACTION_TYPES.SHARED_STATE.SET:
      newState = {
        ...state,
        sharedState: action.payload,
      };
      break;
    case ACTION_TYPES.SHARED_STATE.RESET:
      newState = {
        ...state,
        sharedState: {},
      };
      break;
    // case ACTION_TYPES.CACHED_FUNCTIONS.SET:
    //   newState = {
    //     ...state,
    //     cachedFunctions: {
    //       ...state.cachedFunctions,
    //       [action.payload.name]: action.payload.fn,
    //     },
    //   };
    //   break;
    // case ACTION_TYPES.CACHED_FUNCTIONS.REMOVE:
    //   newState = {
    //     ...state,
    //     cachedFunctions: omit(state.cachedFunctions, action.payload.name),
    //   };
    //   break;
    default:
      break;
  }
  console.log('initial state', state);
  console.log('action', action);
  console.log('next state', newState);
  return newState;
};

export default reducer;
